import React from 'react';
import { Row, Form, Col } from 'antd';
import AssetCatalogUpgradeList from './AssetCatalogUpgradeList';
import AssetCatalogDowngradeList from './AssetCatalogDowngradeList';

export type AssetCatalogUpgradesProps = {
  catalogid: number;
  isModal?: string;
  data:any
  refetch: any;
};

const AssetCatalogUpdgrades = (props: AssetCatalogUpgradesProps) => {
  const { catalogid, isModal ,data,refetch} = props;

  return (
    <Form labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
      <Row gutter={30} justify="space-between">
        <Col lg={12}>
          <AssetCatalogUpgradeList
            catalogid={catalogid}
            isModal={isModal ? isModal : ''}
            UpgradeList={data?.assetUpgradeList}
            refetch={refetch}
          />
        </Col>
        <Col lg={12}>
          <AssetCatalogDowngradeList DowngradeList={data?.assetDowngradeList} />
        </Col>
      </Row>
    </Form>
  );
};

export default AssetCatalogUpdgrades;
